/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import { Route, RouteProps, useLocation } from 'react-router-dom';
import { RoutePath } from './paths';

type GenericRouteProps = RouteProps &
  React.Attributes & {
    path?: RoutePath;
  };

export default function AnimatedRoute({ path, children, key, exact, render }: GenericRouteProps): JSX.Element {
  const location = useLocation();
  const className = 'page-container content-fadein';

  if (children) {
    return (
      <Route path={path as string} key={path} exact={exact}>
        <div className={className}>{children}</div>
      </Route>
    );
  }
  return (
    <Route
      path={path as string}
      key={location.hash || key}
      exact={exact}
      render={(props: any) => <div className={className}>{render && render(props)}</div>}
    />
  );
}
